// Translations
import { DESCRIPTION, TITLE } from '../translations/get-state.translations';

const GET_STATE_LOADER_COMPONENT_PROPS = {
  fetching: true,
  description: DESCRIPTION,
  title: TITLE,
};

const GET_STATE_POLLING_PROPS = {
  timeout: 10, // seconds
};

export { GET_STATE_LOADER_COMPONENT_PROPS, GET_STATE_POLLING_PROPS };
